import { useGetSalaryScales } from 'queries';

export const useGetTableData = () => {
  const { data, isFetching } = useGetSalaryScales();
  return { data, isFetching };
};
